import { usePropertyAutocomplete } from "@/queries/search"
import { useRef, useState } from "react"
import FeedbackTextInput from "@/components/input/FeedbackTextInput"
import {
  type BFDropDownOption,
  BFDropDownPopover,
} from "@/components/standard/BFDropDownPopover"
import { View } from "react-native"
import { Body, H6, Small } from "@/components/standard/BFText"
import { ProductPopup } from "@/screens/loans/components/ProductPopup"
import { useFocusEffect } from "expo-router"
import { noProductYetClicked } from "@/analytics/events/loans"

export const PropertySearchAutocomplete = ({
  onSelect,
  error,
}: {
  error?: string
  onSelect: (option: BFDropDownOption) => void
}) => {
  const [showProductPopup, setShowProductPopup] = useState(false)
  const [mounted, setMounted] = useState(true)
  const [input, setInput] = useState<string>("")
  const { data: properties, isLoading } = usePropertyAutocomplete(input)
  const inputRef = useRef<View>()
  const [dropdownLayout, setDropdownLayout] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  })

  useFocusEffect(() => {
    setMounted(true)
    return () => {
      setMounted(false)
    }
  })

  return (
    // @ts-expect-error ref
    <View ref={inputRef} className={"flex-col gap-2"}>
      <Body>{"What's the property's address?"}</Body>
      <View
        onLayout={() => {
          inputRef.current?.measure((fx, fy, w, h, px, py) => {
            setDropdownLayout({ x: px, y: py, width: w, height: h })
          })
        }}
      >
        <FeedbackTextInput value={input} onChange={setInput} error={error} />
      </View>
      <H6
        onPress={() => {
          noProductYetClicked()
          setShowProductPopup(true)
        }}
        color={"primary"}
      >
        No property, yet?{"   "}
        <Small className={"underline"} color={"primaryLight"}>
          View our Loan Products ›
        </Small>
      </H6>
      {mounted && (
        <BFDropDownPopover
          dropdownLayout={dropdownLayout}
          onSelect={onSelect}
          open={properties && input.length >= 3}
          emptyMessage={
            !isLoading && input.length > 3 && properties?.length === 0
              ? "No properties found. Check your address."
              : undefined
          }
          options={
            properties && properties?.length > 0
              ? properties?.map((property) => ({
                  value: property.placeId,
                  label: property.street,
                  subLabel: property.stateCityZip,
                }))
              : []
          }
        />
      )}
      <ProductPopup
        visible={showProductPopup}
        onClose={() => {
          setShowProductPopup(false)
        }}
      />
    </View>
  )
}
